import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { parserOptions } from "@store/Extensions/Common/BasicSelectorsNoHtmlPageWrapper";
import { COLORS, SPACING, TYPOGRAPHY } from "@store/theme/design";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    configurationCompleted: state.pages.productDetails.configurationCompleted,
});

export interface ProductDetailsAvailabilityStyles {
    availability?: ProductAvailabilityStyles;
    specText?: TypographyProps;
}

export const availabilityStyles: ProductDetailsAvailabilityStyles = {
    // Store Custom Code
    specText: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: bold;
            color: #e37217;
        `,
    },
};

const styles = availabilityStyles;

const ProductDetailsAvailability = ({ product, configurationCompleted }: Props) => {
    if (!product) {
        return null;
    }
    // Store Custom Code
    const refundSpec = product.specifications?.find(spec => spec.name === "Refund Policy");
    let parsedRefundSpec;

    if (refundSpec != null) {
        parsedRefundSpec = parse(refundSpec?.htmlContent, parserOptions);
    } else {
        parsedRefundSpec = null;
    }

    // Store Custom Code
    if (
        product.properties &&
        product.properties.isOutOfMarketMessage &&
        product.properties.isOutOfMarketMessage !== ""
    ) {
        return null;
    }

    return (
        <>
            <ProductContextAvailability
                isProductDetailsPage={true}
                configurationCompleted={configurationCompleted}
                extendedStyles={styles.availability}
            />
            {/* Store Custom Code */}
            <StyledWrapper>
                <Typography {...availabilityStyles.specText}>{parsedRefundSpec}</Typography>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsAvailability)),
    definition: {
        displayName: "Availability",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
